import { logger } from '@/utils/logger';
export const SIDEBAR_UPGRADE_DISMISSED_KEY = 'mora.sidebarUpgrade.dismissed';

export function clearSidebarUpgradeDismissed(): void {
  try {
    localStorage.removeItem(SIDEBAR_UPGRADE_DISMISSED_KEY);
  } catch (err) {
    if (import.meta.env.DEV) logger.warn('[sidebar] localStorage unavailable', err);
  }
}
